import { render, staticRenderFns } from "./MultiTerminalRepair.vue?vue&type=template&id=2297bb12&scoped=true&"
import script from "./MultiTerminalRepair.vue?vue&type=script&lang=js&"
export * from "./MultiTerminalRepair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2297bb12",
  null
  
)

export default component.exports